import React, { useMemo } from "react";
import { useCallback } from "react";
import { hexToWindowsColor } from "../../utils/colors";
import { TextField } from "@material-ui/core";

export const DateEditor = ({ defaultValue = "", updateData }) => {
  const value = useMemo(
    () => defaultValue.split("T")?.[0],
    [defaultValue]
  );

  const dateChange = useCallback(
    (event) => {
      updateData(`${event.target.value}T00:00:00`);
    },
    [updateData]
  );

  return (
    <div className="flex items-center justify-center w-full">
      <TextField
        className="w-full"
        size="small"
        type="date"
        label="Date Of Birth"
        value={value}
        onChange={dateChange}
        variant="outlined"
      />
    </div>
  );
};

class DateCreator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: null,
    };
  }

  handleDateChange = (event) => {
    if (event) {
      this.setState({
        date: event.target.value,
      });
    }
  };

  getFieldValue = () => {
    return new Date(this.state.date);
  };

  render() {
    return (
      <div className="flex items-center justify-center w-full p-2">
        <TextField
          className="w-full"
          size="small"
          type="date"
          label="Date Of Birth"
          value={this.state.date}
          onChange={this.handleDateChange}
          variant="outlined"
        />
      </div>
    );
  }
}

export const createDateCreator = (_, attr, editorClass, ignoreEditable) => {
  return (
    <DateCreator
      ref={attr.ref}
      editorClass={editorClass}
      ignoreEditable={ignoreEditable}
    />
  );
};

export const createDateEditor = (onUpdate, props) => {
  return <DateEditor updateData={onUpdate} {...props} />;
};
